import React from 'react'
import { MenuButton, Icon } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'

const DisableUsageReminder = ({ task, refetch, readOnly }) => {
  const { formatMessage } = useIntl()

  if (task?.type?.shortname !== 'USAGE') {
    return null
  }

  const onClick = () => {
    fetch(`/rest/v2/task/${task.uid}`, {
      method: 'PUT',
      body: JSON.stringify({
        usage_reminder_disabled: !!(+task.usage_reminder_disabled) ? 0 : 1
      })
    })
      .then((response) => response.json())
      .then(() => {
        if (!!(+task.usage_reminder_disabled)) {
          toastr.success(formatMessage(messages.enabled))
        } else {
          toastr.success(formatMessage(messages.disabled))
        }
        refetch()
      })
      .catch((error) => window.alert(error))
  }

  return (
    <Menu.Item key='DisableUsageReminder' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          <div className="flex justify-between items-center space-x-4">
            <span>{formatMessage(messages.title)}</span>
            <Icon icon={!!(+task.usage_reminder_disabled) ? 'check-square' : 'square'} />
          </div>
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default DisableUsageReminder
